e4.productlist = {
    debug: false,
    jProductList: jQuery( '.js-e-productlist' ),
    init: function () {

        if ( e4.productlist.jProductList.length === 1 ) {
            e4.productlist.initialLoad = true;
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-productlist-filters #js-e-handlebars-tmpl-productlist-products #js-e-handlebars-tmpl-productlist-sort #js-e-handlebars-tmpl-favorite-list' );
                e4.handlebars.registerPartials( '#js-e-handlebars-tmpl-productlist-product-partial' );
                e4.productlist.event = e4.util.registerEvents( 'build builded insert inserted', 'productlist' );
                e4.productlist.bindEvents();
                e4.productlist.history.init();
                e4.productlist.filters.init();
            } );
        }
    },
    bindEvents: function () {
        e4.productlist.jProductList.on( 'change', '.js-e-productlist-sort-select', function ( event ) {
            e4.productlist.setSort( event.target );
        } );
        e4.productlist.jProductList.on( 'click', '.js-e-productlist-item a', function ( event ) {
            event.preventDefault();
            e4.productlist.navigateToProductPage( event.currentTarget );
        } );
        e4.productlist.jProductList.on( 'click', '.js-e-productlist-load-more-products-btn', function ( event ) {
            event.preventDefault();
            e4.productlist.lazyload.loadNextItems();
        } );

        e4.productlist.jProductList.find( '.js-e-productlist-favorite-list-add-button' ).on( 'click', e4.productlist.toggleFavoriteCreateList );
        e4.productlist.jProductList.on( 'click', '.js-e-productlist-favorite-list-add-button', e4.productlist.toggleFavoriteCreateList );

        jQuery( window )
            .on( 'resize', e4.util.debounce( e4.productlist.filters.toggleMarkupPlacement, e4.settings.debounceDelay.resize ) )
            .on( 'beforeunload', function () {
                if ( e4.settings.ecom.filters.cleanUrl === true ) {
                    e4.productlist.history.clearState();
                }
            } );

        e4.productlist.jProductList.on('click', '.js-bloomingville-addtocart-btn', function(event){
            var jElement = jQuery(event.target);
            jElement.text(jElement.data('addedText'));
            jElement.removeClass();
            jElement.addClass('btn bg-light border mb-0 text-dark btn-block px-0');
        });

        e4.productlist.jProductList.on( e4.productlist.event.builded, function ( event, jsonData ) {
            e4.productlist.showLoadMoreButtonOrAutoLoad( jsonData );
        } );
    },
    toggleFavoriteCreateList: function ( event ) {
        event.preventDefault();
        event.stopPropagation();
        var jTarget = jQuery( event.target ).closest( '.js-e-productlist-favorite-list-container' ).find( '.js-e-product-favorite-list-add' );
        jTarget.collapse( 'toggle' );
    },
    ajax: function ( objAjaxSettings, strUrlParam ) {
        if ( strUrlParam === undefined ) {
            strUrlParam = e4.productlist.getParamsFromForm();
        }

        var jqXHR = jQuery.ajax( jQuery.extend( {
            method: 'GET',
            dataType: 'json',
            url: e4.productlist.getFeedUrl(),
            cache: false,
            data: strUrlParam,
        }, objAjaxSettings ) );

        jqXHR.fail( function ( jqXHR, textStatus, errorThrown ) {
            jQuery( '#js-e-productlist-products' ).html( '<h4>' + errorThrown + '</h4>' );
        } );
        jqXHR.always( function () {
            e4.loading.resolveWait( '.js-e-productlist' );
            e4.productlist.history.setParams( strUrlParam );
            jQuery( '.js-e-productlist-loading-overlay' ).removeClass( 'is-loading' );
            // console.trace(jsonData);
        } );
        return jqXHR;
    },
    getFeedUrl: function () {
        // Get custom filters data-feed url if any, to support alternative feeds.
        var strCustomUrl = e4.productlist.jProductList.find( '.js-e-productlist-form' ).data( 'action' );
        return strCustomUrl !== '' ? strCustomUrl : e4.settings.ecom.filters.url;
    },
    getParamsFromForm: function () {
        return e4.productlist.jProductList.find( '.js-e-productlist-form' ).serialize();
    },
    showLoadMoreButtonOrAutoLoad: function ( jsonData ) {
        // Callback for the builded event
        var hasMorePages = jsonData.moduleSettings.pageCount > 1,
            isLastPage = e4.productlist.lazyload.currentPage === jsonData.moduleSettings.pageCount,
            isAutoLazyload = jsonData.moduleSettings.productCount < e4.settings.ecom.lazyload.autoLoadCount;

        if ( hasMorePages === true && isLastPage === false && isAutoLazyload === false ) {
            // Show load-more btn if we have more pages and the setting for auto-lazyload is not achieved by the total count of products
            e4.productlist.lazyload.showLoadMoreButton();
        }
        else {
            // Hide load-more button if it is the last page (or the setting for auto-lazyload is achieved by the total count of products)
            e4.productlist.lazyload.hideLoadMoreButton();
            if ( isAutoLazyload === true ) {
                var arrObservables = jQuery( '#js-e-productlist-products' ).find( '.js-e-productlist-item' ).last().toArray();
                e4.util.observer.bind( arrObservables, e4.productlist.lazyload.onLastItemIntersection, e4.settings.ecom.lazyload.observerOptions );
            }
        }
    },
    navigateToProductPage: function ( domElm ) {
        jQuery( window ).off( 'beforeunload' );
        jQuery.when( e4.productlist.getPageNumberByProductItemIndex( domElm ) ).then( function ( intPageNumber ) {
            e4.productlist.history.setState( { PageNum: intPageNumber } );
            location.href = domElm.href;
        } );
    },
    lazyload: {
        init: function () {
            // Get settings from data-attr and set global variables to use in the global scope
            if ( e4.util.observer.isSupported === true ) {
                var objProductlistSettings = e4.productlist.jProductList.data();
                e4.productlist.lazyload.currentPage = objProductlistSettings.currentPage;
                e4.productlist.lazyload.pageCount = objProductlistSettings.pageCount;

                var arrObservableSkeletons = jQuery( '.js-e-productlist-skeleton-item' ).filter( '.is-observable' ).toArray(),
                    jLastItem = jQuery( '#js-e-productlist-products' ).find( '.js-e-productlist-item' ).last(),
                    isLastPage = e4.productlist.lazyload.currentPage === e4.productlist.lazyload.pageCount;

                if ( arrObservableSkeletons.length > 0 ) {
                    e4.productlist.lazyload.setSkeletonItemHeight();
                    e4.util.observer.bind( arrObservableSkeletons, e4.productlist.lazyload.onSkeletonIntersection, e4.settings.ecom.lazyload.observerOptions );
                    if ( isLastPage === false ) {
                        // Load the next page automatically if the last product-item is visible in the viewport
                        if ( e4.util.isInViewport( jLastItem ) === true ) {
                            e4.productlist.lazyload.loadNextItems();
                        }
                    }
                }
            }
            else {
                e4.util.debug(
                    [
                        'IntersectionObserver not available',
                        'switching to pagination'],
                    e4.productlist.debug );
                jQuery( '.js-e-productlist-pagination' ).prop( 'hidden', false );
                e4.productlist.jProductList.addClass( 'is-pagination' );
            }


        },
        loadNextItems: function () {
            // Manually load next batch on click load-more btn or if last server-loaded productitem is in viewport
            var intCurrentPageNum = e4.productlist.getPageNumber();
            e4.productlist.lazyload.hideLoadMoreButton();
            e4.productlist.lazyloadProducts( ( intCurrentPageNum + 1 ), e4.productlist.lazyload.appendItems );
        },
        onLastItemIntersection: function ( objEntry, objObserver ) {
            if ( objEntry.isIntersecting === true ) {
                var intPageNumber = e4.productlist.getPageNumber();
                intPageNumber++;
                objObserver.unobserve( objEntry.target );
                e4.productlist.lazyloadProducts( intPageNumber, e4.productlist.lazyload.appendItems );
            }
        },
        appendItems: function ( jsonData ) {
            // append each product in fetched json to end of productlist with partial
            jQuery.each( jsonData.products, function ( intIndex, objProduct ) {
                /*e4.productlist.jProductList.trigger( e4.productlist.event.insert, objProduct );*/
                objProduct.listItemHtml = bloomingville.regexReplace.convert(objProduct.listItemHtml);
                jQuery( '#js-e-productlist-products' ).append( e4.handlebars.partial.productlistProductPartial( objProduct.listItemHtml ) );
                e4.productlist.jProductList.trigger( e4.productlist.event.inserted, objProduct );
            } );
            e4.productlist.setPageNumber( jsonData.moduleSettings.pageNum );
            e4.productlist.lazyload.bindAutoLoadOrShowLoadMoreButton( jsonData );
        },
        onSkeletonIntersection: function ( objEntry, objObserver ) {
            if ( objEntry.isIntersecting === true ) {
                var jEntryTarget = jQuery( objEntry.target ),
                    intPageNumber = e4.productlist.getPageNumber();
                if ( jEntryTarget.is( '.is-observable' ) === true ) {
                    intPageNumber = parseInt( jEntryTarget.data( 'page' ) );
                }
                objObserver.unobserve( objEntry.target );
                e4.productlist.lazyloadProducts( intPageNumber, e4.productlist.lazyload.replaceSkeletonItems );
            }
        },
        replaceSkeletonItems: function ( jsonData ) {
            // replace each matching skeleton item (by pagenum and index) with matching product in fetched json with partial
            jQuery.each( jsonData.products, function ( intIndex, objProduct ) {
                var intPagenum = jsonData.moduleSettings.pageNum,
                    jSkeletonItem = e4.productlist.lazyload.getSkeletonItem( intPagenum, intIndex );
                if ( jSkeletonItem !== undefined ) {
                    jSkeletonItem.parent().replaceWith( e4.handlebars.partial.productlistProductPartial( objProduct.listItemHtml ) );
                    e4.productlist.jProductList.trigger( e4.productlist.event.inserted, objProduct );
                }
            } );
        },
        bindAutoLoadOrShowLoadMoreButton: function ( jsonData ) {
            if ( jsonData.moduleSettings.pageNum < jsonData.moduleSettings.pageCount ) {
                var isShowInterval = jsonData.moduleSettings.pageNum % e4.settings.ecom.lazyload.buttonShowInterval === 0,
                    isNextPageFull = jsonData.moduleSettings.productCount - ( jsonData.moduleSettings.pageSize * jsonData.moduleSettings.pageNum ) > jsonData.moduleSettings.pageSize,
                    isAutoLazyload = jsonData.moduleSettings.productCount < e4.settings.ecom.lazyload.autoLoadCount;
                if ( isShowInterval === true && isNextPageFull === true && isAutoLazyload === false ) {
                    // if current pageNum matches the setting for the load-more button show interval (by modulus)
                    // and the next page is calculated to be a full pagesize
                    // and the setting for auto-lazyload is not achieved by the total count of products
                    e4.productlist.lazyload.showLoadMoreButton();
                }
                else {
                    var arrObservables = jQuery( '#js-e-productlist-products' ).find( '.js-e-productlist-item' ).last().toArray();
                    e4.util.observer.bind( arrObservables, e4.productlist.lazyload.onLastItemIntersection, e4.settings.ecom.lazyload.observerOptions );
                }
            }
            else {
                e4.productlist.lazyload.hideLoadMoreButton();
            }
        },
        showLoadMoreButton: function () {
            jQuery( '.js-e-productlist-load-more-products-btn' ).removeClass( 'd-none' );
        },
        hideLoadMoreButton: function () {
            jQuery( '.js-e-productlist-load-more-products-btn' ).addClass( 'd-none' );
        },
        getSkeletonItem: function ( intPageNumber, intIndex ) {
            return jQuery( '#js-e-productlist-products' ).find( '.js-e-productlist-skeleton-item[data-page="' + intPageNumber + '"][data-index="' + intIndex + '"]' );
        },
        setSkeletonItemHeight: function () {
            // Get and set the height of the skeleton items.
            var intFirstItemHeight = jQuery( '#js-e-productlist-products' ).find( '.js-e-productlist-item' ).first().outerHeight();
            jQuery( '.js-e-productlist-skeleton-item' ).css( { height: intFirstItemHeight } );
        }
    },
    filters: {
        init: function () {
            e4.productlist.filters.bindEvents();
            e4.productlist.filters.popper.init();
        },
        bindEvents: function () {
            e4.productlist.jProductList.find( '.js-e-productlist-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                e4.productlist.loadListAndFilters();
            } );
            e4.productlist.jProductList.on( 'change', '.js-e-productlist-filter', function ( event ) {
                e4.productlist.filters.applyFilters( event.target );
            } );
            e4.productlist.jProductList.on( 'click', '.js-e-productlist-filters-remove', function ( event ) {
                event.preventDefault();
                e4.productlist.filters.removeFilter( event.currentTarget );
            } );
            jQuery( document ).on( 'click', '.js-e-productlist-filters-clear-all', function ( event ) {
                event.preventDefault();
                e4.productlist.filters.resetAll();
            } );
            e4.productlist.jProductList.on( 'change', '.js-e-productlist-filters-option-reset-group', function ( event ) {
                event.preventDefault();
                if ( jQuery( event.target ).is( ':checked' ) === true ) {
                    e4.productlist.filters.resetGroup( event.target );
                }
                else {
                    jQuery( event.target ).prop( 'checked', true );
                }
            } );
            // Search.
            e4.productlist.jProductList.on( 'keyup', '.js-e-search-input', function ( event ) {
                if ( event.which === 13 ) {
                    e4.productlist.filters.applyFilters( event.target );
                }
            } );
            e4.productlist.jProductList.on( 'click', '.js-e-productlist-filters-search-clear', function ( event ) {
                event.preventDefault();
                e4.productlist.jProductList.find( '.js-e-search-input' ).val( '' );
                e4.productlist.filters.applyFilters( event.target );
            } );
            e4.productlist.jProductList.on( 'click', '.js-e-search-clear', function ( event ) {
                e4.search.clearInput( event.target );
            } );


        },
        popper: {
            init: function () {
                var intWindowWidth = jQuery( window ).width();
                if ( intWindowWidth > 1364 ) {
                    e4.productlist.filters.popper.bindEvents();
                }
            },
            bindEvents: function () {
                jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
                    jQuery('.js-e-productlist-filters-group .e-productlist-filters-group-collapse-toggle').removeAttr("data-toggle");
                });
                jQuery( 'body' ).on( 'click', '[data-popper="trigger"]', function ( event ) {
                    e4.productlist.filters.popper.trigger( event.currentTarget );
                } ).on( 'click', function ( event ) {
                    e4.productlist.filters.popper.toggle( event.target );
                } );
            },
            trigger: function ( domElm ) {
                var reference = jQuery( domElm ),
                    popper = reference.closest( '.js-e-productlist-filters-group' ).find( domElm.dataset.target ),
                    referenceParentSiblingsTrigger = reference.closest( '.js-e-productlist-filters-group' ).siblings();


                var popit = new Popper( reference, popper, {
                    placement: 'bottom',
                    modifiers: {
                        flip: {
                            behavior: [
                                'left',
                                'right'
                            ]
                        }
                    }
                } );

                jQuery.each( referenceParentSiblingsTrigger, function ( index, domElm ) {
                    jQuery( domElm ).find( '[data-popper="trigger"]' ).removeClass( 'open' );
                    jQuery( domElm ).find( '[data-popper="target"]' ).addClass( 'closed' );
                } );
                reference.toggleClass( 'open' );
                jQuery( popper ).toggleClass( 'closed' );
            },
            toggle: function ( domElm ) {
                var isTriggerElement = jQuery( domElm ).data( 'popper' ) === 'trigger',
                    hasTriggerChildren = jQuery( domElm ).parents( '[data-popper="trigger"]' ).length > 0,
                    isTargetElement = jQuery( domElm ).data( 'popper' ) === 'target',
                    hasTargetChildren = jQuery( domElm ).parents( '[data-popper="target"]' ).length > 0;
                if ( isTriggerElement === false && hasTriggerChildren === false && isTargetElement === false && hasTargetChildren === false ) {
                    jQuery( '[data-popper="trigger"]' ).removeClass( 'open' );
                    jQuery( '[data-popper="target"]' ).addClass( 'closed' );
                }
            }
        },
        refresh: function () {
            e4.productlist.filters.collapse.init();
        },
        applyFilters: function ( domElm ) {
            var jThis = jQuery( domElm ),
                jFilterGroupAllOptionInput = jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ),
                intFilterGroupAppliedOptionCount = jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).filter( ':checked' ).length;
            if ( jFilterGroupAllOptionInput.length > 0 ) {
                // Un-check the "all-option" in current group if any other options is checked and vice versa.
                if ( intFilterGroupAppliedOptionCount > 0 ) {
                    jFilterGroupAllOptionInput.prop( 'checked', false );
                }
                else {
                    jFilterGroupAllOptionInput.prop( 'checked', true );

                }
            }
            e4.productlist.setPageNumber( 1 );
            e4.productlist.loadListAndFilters();
        },
        removeFilter: function ( domElm ) {
            var strValue = jQuery( domElm ).data( 'value' );
            e4.productlist.jProductList.find( '.js-e-productlist-filter[value="' + strValue + '"]' ).prop( 'checked', false );
            e4.productlist.setPageNumber( 1 );
            e4.productlist.loadListAndFilters();
        },
        resetGroup: function ( domElm ) {
            jQuery( domElm ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.productlist.setPageNumber( 1 );
            e4.productlist.loadListAndFilters();
        },
        resetAll: function () {
            e4.productlist.jProductList.find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.productlist.jProductList.find( '.js-e-search-input' ).val( '' );
            e4.productlist.setPageNumber( 1 );
            e4.productlist.loadListAndFilters();
        },
        toggleMarkupPlacement: function () {
            var jFilters = jQuery( '#js-e-productlist-filters' ),
                strFiltersHtml = jQuery.trim( jFilters.html() ),
                jFiltersModalBody = jQuery( '#js-e-productlist-filters-modal' ).find( '#js-e-productlist-filters-modal-body' ),
                strFiltersModalBodyHtml = jQuery.trim( jFiltersModalBody.html() );
            if ( jFilters.is( ':visible' ) === true ) {
                if ( strFiltersHtml === '' ) {
                    jFilters.html( strFiltersModalBodyHtml );
                    jFiltersModalBody.html( '' );
                }
            }
            else {
                if ( strFiltersModalBodyHtml === '' ) {
                    jFiltersModalBody.html( strFiltersHtml );
                    jFilters.html( '' );
                }
            }
        }
    },
    setPageNumber: function ( intPageNumber ) {
        e4.productlist.jProductList.find( 'input[name="PageNum"]' ).val( intPageNumber );
    },
    getPageNumber: function () {
        var intPageNumber = parseInt( e4.productlist.jProductList.find( 'input[name="PageNum"]' ).val() );
        if ( isNaN( intPageNumber ) === true ) {
            intPageNumber = 1;
        }
        return intPageNumber;
    },
    getPageNumberByProductItemIndex: function ( domElm ) {
        var intPageSize = parseInt( e4.productlist.jProductList.data( 'pageSize' ) ),
            intProductItemIndex = ( jQuery( domElm ).closest( '.js-e-productlist-item' ).parent().index() + 1 ),
            intPageNumber = Math.ceil( intProductItemIndex / intPageSize );
        return intPageNumber;
    },
    setSort: function ( domElm ) {
        if(jQuery( domElm ).val() === null){
            var strDefaultVal = jQuery( domElm ).find('option').eq(0).val();
            jQuery( domElm ).val(strDefaultVal).trigger('change');
            return false;
        }
        var arrSelectSortValue = jQuery( domElm ).val().split( ' ' );

        if ( arrSelectSortValue.length === 2 ) {
            e4.productlist.setStoredSortVal(e4.productlist.jProductList, jQuery( domElm ).val());
            e4.productlist.jProductList.find( 'input[name="Sort"]' ).val( arrSelectSortValue[ 0 ] + ' ' + arrSelectSortValue[ 1 ] );
            e4.productlist.jProductList.find( 'input[name="SortBy"]' ).val( arrSelectSortValue[ 0 ] );
            e4.productlist.jProductList.find( 'input[name="SortOrder"]' ).val( arrSelectSortValue[ 1 ] );
        }
        else {
            e4.productlist.clearStoredSortVal(e4.productlist.jProductList);

            e4.productlist.jProductList.find( 'input[name="SortBy"], input[name="SortOrder"]' ).val( '' );
        }
        e4.productlist.setPageNumber( 1 );
        e4.productlist.loadListAndFilters();
    },
    setScrollTop: function ( intScrollTop ) {
        // If no value is passed with arguments, we set default scroll position to product list root node position.
        if ( intScrollTop === undefined ) {
            intScrollTop = e4.productlist.getScrollTop();
            var jWindow = jQuery( window ),
                jFirstItem = e4.productlist.jProductList.find( '.js-e-productlist-item' ).first();
            if ( intScrollTop < jWindow.scrollTop() && jFirstItem.length === 1 && e4.util.isInViewport( jFirstItem ) === false ) {
                intScrollTop -= jWindow.height() / 100 * e4.settings.scrollToAnchor.nudge;
                e4.scrollToAnchor.animate( intScrollTop, e4.header.hide );
            }
        }
        // If a value is passed with arguments, we are restoring af history state with a scroll position saved when clicking a product.
        else {
            jQuery( 'html,body' ).scrollTop( intScrollTop );
        }
    },
    getScrollTop: function () {
        return Math.ceil( e4.productlist.jProductList.offset().top );
    },
    history: { // TODO rename det er det styrende namespace som loader listen første gang og navnet konflikter hårdt med det native js api 'history'
        params: null,
        init: function () {
            e4.productlist.history.title = document.title;
            if ( history.state !== null && history.state.params !== '' ) {
                e4.productlist.serverBuild = false;
                e4.productlist.history.title = history.state.title || '';
                e4.productlist.loadListAndFilters( history.state.scrollTop, history.state.params );
            }
            else {
                var intPageNumber = e4.productlist.getPageNumber();
                if ( intPageNumber > 1 ) {
                    var jFirstItem = e4.productlist.jProductList.find( '.js-e-productlist-item' ).first(),
                        intScrollTop = intPageNumber > 1 ? jFirstItem.offset().top : 0;
                    e4.productlist.loadListAndFilters( intScrollTop );
                }
                else {
                    e4.productlist.loadListAndFilters();
                }

            }
        },
        setState: function ( objParams ) {
            objParams = objParams || {};

            if ( jQuery.isEmptyObject( objParams ) === false ) {
                e4.productlist.history.updateParams( objParams );
            }

            var stateObj = {
                    params: e4.productlist.history.getParams(),
                    scrollTop: jQuery( window ).scrollTop(),
                    title: e4.productlist.history.title
                },
                boolCleanUrl = e4.settings.ecom.filters.cleanUrl;

            if ( objParams.PageNum !== undefined ) {
                boolCleanUrl = false;
            }

            history.replaceState( stateObj, e4.productlist.history.title, location.pathname + ( boolCleanUrl ? '' : '?' + e4.productlist.history.getParams() ) );
            document.title = e4.productlist.history.title;
        },
        clearState: function () {
            history.replaceState( null, '', null );
        },
        setParams: function ( strUrlParam ) {
            e4.productlist.history.params = strUrlParam;
        },
        getParams: function () {
            return e4.productlist.history.params;
        },
        updateParams: function ( objParams ) {
            var strUrlParams = e4.productlist.history.getParams(),
                arrUpdatedUrlParams = [];
            if ( strUrlParams === '' ) {
                strUrlParams = e4.productlist.getParamsFromForm();
            }
            strUrlParams = strUrlParams.split( '&' );

            if ( objParams !== undefined ) {
                for ( var i = 0; i < strUrlParams.length; i++ ) {
                    var arrKeyValue = strUrlParams[ i ].split( '=' );
                    if ( objParams[ arrKeyValue[ 0 ] ] ) {
                        arrKeyValue[ 1 ] = objParams[ arrKeyValue[ 0 ] ];
                    }
                    strUrlParams[ i ] = arrKeyValue.join( '=' );
                    arrUpdatedUrlParams.push( strUrlParams[ i ] );
                }

                Object.keys( objParams ).forEach( function ( key ) {
                    var jInput = jQuery( 'input[name="' + key + '"]' );
                    if ( jInput.length > 0 ) {
                        jInput.val( objParams[ key ] );
                    }
                } );

                strUrlParams = arrUpdatedUrlParams.join( '&' );
                e4.productlist.history.setParams( strUrlParams );
            }
        }
    },
    lazyloadProducts: function ( intPageNumber, fnCallback ) {
        e4.productlist.setPageNumber( intPageNumber );
        e4.productlist.ajax().done( function ( jsonData ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( jsonData );
            }
        } );
    },
    loadListAndFilters: function ( intScrollTop, strUrlParam ) {
        e4.productlist.ajax( {
            beforeSend: function () {
                if ( e4.productlist.initialLoad !== true ) {
                    jQuery( '.js-e-productlist-loading-overlay' ).addClass( 'is-loading' );
                }
            }
        }, strUrlParam ).done( function ( jsonData ) {
            e4.productlist.jProductList.trigger( e4.productlist.event.build );
            e4.productlist.history.setState();
            e4.productlist.buildFilters( jsonData );
            e4.productlist.buildList( jsonData );
            e4.productlist.setScrollTop( intScrollTop );
            e4.productlist.jProductList.trigger( e4.productlist.event.builded, jsonData );
        } );
    },
    buildList: function ( jsonData ) {
        jQuery( '.js-e-productlist-product-count' ).html( jsonData.moduleSettings.productCount );
        if ( e4.productlist.initialLoad !== true ) {
            var convertedHtml = bloomingville.regexReplace.convert(e4.handlebars.tmpl.productlistProducts( jsonData ));
            jQuery( '#js-e-productlist-products' ).html( convertedHtml );
        }
        else {
            e4.productlist.lazyload.init();
        }
        e4.productlist.initialLoad = false;
    },
    serverBuild: true,
    getSectionId: function(jProductList){
        return 'global.productlist.sort';// jProductList.closest('.js-e-productlist').data('paragraphid');
    },
    getStoredSortVal: function(jProductList){
        return window.localStorage.getItem(e4.productlist.getSectionId(jProductList));
    },
    clearStoredSortVal: function(jProductList){
        window.localStorage.removeItem(e4.productlist.getSectionId(jProductList));
    },
    setStoredSortVal: function(jProductList, strValue){
        window.localStorage.setItem(e4.productlist.getSectionId(jProductList), strValue);
    },
    buildFilters: function ( jsonData ) {
        var jFilters = jQuery( '#js-e-productlist-filters' ),
            jFiltersModalBody = jQuery( '#js-e-productlist-filters-modal' ).find( '#js-e-productlist-filters-modal-body' ),
            jSort = jQuery( '.js-e-productlist-sort' );
        if ( jFilters.length === 1 ) {
            var strFiltersHtml = e4.handlebars.tmpl.productlistFilters( jsonData );
            if ( jFilters.is( ':visible' ) === true ) {
                jFilters.html( strFiltersHtml );
                jFiltersModalBody.html( '' );
            }
            else {
                jFiltersModalBody.html( strFiltersHtml );
                jFilters.html( '' );
            }
        }
        if ( jSort.length > 0 ) {
            jSort.html( e4.handlebars.tmpl.productlistSort( jsonData ) );
            if(e4.productlist.serverBuild && e4.productlist.getStoredSortVal(e4.productlist.jProductList) != null){
                e4.productlist.jProductList.find( '.js-e-productlist-sort-select').val(e4.productlist.getStoredSortVal(e4.productlist.jProductList));
                e4.productlist.jProductList.find( '.js-e-productlist-sort-select').trigger('change');
                e4.productlist.serverBuild = false;
            }
        }
        jQuery( '.js-e-productlist-filters-applied-count' ).html( jsonData.filtersAppliedCount === 0 ? '' : jsonData.filtersAppliedCount );
    }
};
